import format from '@/utils/format';

const checkStockControl = 20000;
const maxSalePrice = 1000000;
export default {
  install (Vue, Validator) {
    Validator.extend('existsArray', {
      getMessage: field => `Aynı ${field} değeri mevcut`,
      validate: (val, fields) => {
        const obList = fields[0];
        const obKey = fields[1];
        const obLineNumber = fields[2];
        if (obList instanceof Object) {
          const exists = Object.keys(obList).filter(k => obList[k][obKey] === val && parseInt(k, 10) !== obLineNumber).length > 0;
          if (!exists) {
            return true;
          }
        }
        return false;
      },
    });
    Validator.extend('isLth', {
      getMessage: field => `${field}, Piyasa satış fiyatından büyük olamaz.`,
      validate: (val, fields) => {
        if (!val || !fields[0]) {
          return true;
        }
        const value = format.priceToNumber(val);
        const otherValue = format.priceToNumber(fields[0]);
        return value <= otherValue;
      },
    });
    Validator.extend('configMax', {
      getMessage: () => `Tedarik edememe riskini önlemek adına ürününüze tek seferde en fazla ${checkStockControl} adet stok ekleyebilirsiniz.`,
      validate: (val) => {
        if (!val) {
          return true;
        }
        if (checkStockControl <= 0) {
          return true;
        }
        const value = parseInt(val);
        return value <= checkStockControl;
      },
    });
    Validator.extend('maxSalePrice', {
      getMessage: () =>
        `Platform Kuralları gereği, ${maxSalePrice} TL ve üzerindeki fiyatlarla ürün girişi yapılamamaktadır.`,
      validate: (val) => {
        const value = parseInt(val);
        return value < maxSalePrice;
      },
    });
    Validator.extend('requiredSelect', {
      getMessage: field => `${field} alanı boş olamaz.`,
      validate: value => (!!value.label || !!value.Name),
    });
    Validator.extend('notValid', {
      getMessage: (field, fields) => {
        let notValid = '';
        let hasSpace = false;
        if (fields[0]) {
          notValid = fields[0].replace(/\[/gi, '').replace(/]/gi, '').replace(/\\/, '');
          hasSpace = fields[0].match(/\s/g);
        }
        return `Bu alanda <b>${hasSpace ? 'Boşluk' : ''}${notValid}</b> karakterlerini kullanamazsınız.`;
      },
      validate: (value, fields) => {
        const regex = new RegExp(fields[0], 'gi');
        return !value.match(regex);
      },
    });
    Validator.extend('validBarcode', {
      getMessage: () => '"_-." dışında özel karakter giremezsiniz!',
      validate: (val, fields) => {
        const regex = new RegExp(fields[0]);
        return !!val.match(regex);
      },
    });
    Validator.extend('validDeliveryDuration', {
      getMessage: (field, fields) => {
        return `Barkodlarınıza ait girebileceğiniz sevkiyat süresi ${fields.deliveryPeriod.minAgreedDeliveryTime} - ${fields.deliveryPeriod.deliveryDeadlineTime} gün aralığında olmalıdır.`;
      },
      validate: (value, fields) => {
        return value && value <= fields.deliveryPeriod.deliveryDeadlineTime && value >= fields.deliveryPeriod.minAgreedDeliveryTime;
      },
    });
  },
};
